const getDefaultState = () => ({
  domains: {
    items: [],
    loading: false,
    error: false,
    noContent: false,
  },
  types: {
    items: [],
    loading: false,
    error: false,
  },
  templates: {
    domain: null,
    triggerType: null,
    templates: {
      items: [],
      loading: false,
      error: false,
      noContent: false,
    },
    save: {
      loading: false,
      error: false,
    },
  },
  rules: {
    domain: null,
    triggerType: null,
    currentRevision: null,
    rules: {
      item: {},
      loading: false,
      error: false,
      noContent: false,
    },
    templates: {
      items: [],
      loading: false,
      error: false,
      noContent: false,
    },
    save: {
      loading: false,
      error: false,
    },
    revisions: {
      items: [],
      loading: false,
      error: false,
      noContent: false,
    },
    settings: {
      list: {
        items: [],
        loading: false,
        error: false,
        noContent: false,
      },
      logs: {
        items: [],
        loading: false,
        error: false,
      },
      action: {
        loading: false,
        error: false,
      },
      delete: {
        loading: false,
        error: false,
      },
    },
  },
  lists: {
    preview: {
      loading: false,
      item: null,
      error: false,
    },
    overview: {
      loading: false,
      item: null,
      error: false,
    },
    list: {
      loading: false,
      items: [],
      error: false,
    },
    messages: {
      messages: {
        items: [],
        loading: false,
        error: false,
      },
      booking: null,
    },
    filters: {
      chosenDomains: [],
      showMessages: 'all',
      showCancelled: 'all',
      search: null,
    },
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/triggers/defaultState.js